export default "__VITE_PUBLIC_ASSET__18fb0e42__"